import React, { useEffect, useState } from "react";
import TitleBar from "../../common/title-bar/title-bar";
import Table from "../../common/table";
import Button from "../../common/button/button";
import { useParams, useLocation } from "react-router-dom";
import TableOptionsCell from "../../common/table/table-options-cell";
import APIService from "../../Service/APIService";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useAuth } from '../AuthProvider.js';
import Swal from "sweetalert2";
import { colors } from "../../theme/colors.js";
import { hasPermission } from "../../Config/permissions.js";

const CommissionStatementsProducts = () => {
  const { user } = useAuth();
  const userData = user;
  const { id } = useParams();
  const [commissionData, setCommissionData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const getData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.addDataToBackend(
      {
        InvoiceID: id,
        CommissionStatementID: location.state?.CommissionStatementID || null,
        DistributorID: location.state?.DistributorID || null,
      },
      "getcommissionsforinvoice"
    );
    console.log("getData", response.data.data);
    if (response) {
      return response?.data?.data || [];
    }
    return [];
  };

  const fetchDist = async (distID) => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("getdistributorbyid?ID=" + distID);
    return response?.data?.data;
  }

  const fetchInvoice = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("getinvoicebyid?ID=" + id);
    return response?.data?.data;
  }

  useEffect(() => {
    // dummyCommissionStatementsProducts.find((el) => {
    //   if (Number(id) === el.DistributorID) {
    //     setCommProduct(el);
    //   }
    // });
    if (userData && userData.Type === "Account") {
      navigate(`/Account/${userData.AccountID}`);
      window.location.reload();
    } else if (userData && userData.Type === "Distributor") {
      fetchDist(userData.DistributorID).then((data)=>{
        if(!userData.IsManager || !data.EnableCommissionModule){
          navigate(`/Distributor/${userData.DistributorID}`);
          window.location.reload();
        }
        else{
          fetchInvoice().then((data)=>{
            if(data.DistributorID != userData.DistributorID){
              navigate(`/Distributor/${userData.DistributorID}`);
              window.location.reload();
            }
          })
        }
      });
    } else if (
      userData &&
      ["Admin", "ASD", "Authorizer", "Viewer"].includes(userData.Type) &&
      !hasPermission(userData, "commission_stmt.view")
    ) {
      navigate("/");
      window.location.reload();
    } else if(userData && userData?.Type === "Manufacturer") {
      navigate("/");
      window.location.reload();
    }
    getData().then((data) => {
      setCommissionData(data);
    });
  }, [id]);

  const canResetCommission =
    ["Admin", "ASD", "Authorizer", "Viewer"].includes(userData?.Type) &&
    hasPermission(userData, "payment.reset") &&
    hasPermission(userData, "commission.reset");

  const resetCommission = (rowData) => {
    if (!rowData?.CommissionID) {
      Swal.fire({
        icon: "error",
        title: "Missing Commission",
        text: "Unable to reset commission because the commission row is missing.",
      });
      return;
    }

    if (!rowData?.CanResetCommission) {
      Swal.fire({
        icon: "warning",
        title: "Commission Reset Not Allowed",
        text:
          rowData?.ResetBlockedReason ||
          "This commission cannot be reset.",
      });
      return;
    }

    Swal.fire({
      title: "Reset this commission?",
      text: "This will remove only the selected commission row. Payments and generated statements will not be changed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["failureColor"],
      cancelButtonColor: colors["lightText"],
      confirmButtonText: "Reset Commission",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      try {
        const apiServe = new APIService();
        const response = await apiServe.addDataToBackend(
          {
            CommissionID: rowData.CommissionID,
            InvoiceID: rowData.InvoiceID,
          },
          "resetcommission"
        );
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire("Reset!", "Commission Reset!", "success");
          const updatedData = await getData();
          setCommissionData(updatedData);
        } else {
          Swal.fire({
            icon: "error",
            title: "Commission Reset Failed",
            text: response?.data?.message || "Please try again.",
          });
        }
      } catch (error) {
        console.error("Failed to reset commission", error);
        Swal.fire({
          icon: "error",
          title: "Commission Reset Failed",
          text: error?.response?.data?.message || "Please try again.",
        });
      }
    });
  };

  const tableHeadersCommissionsStatementsProducts = [
    {
      headerName: "Tissue ID",
      field: "TissueID",
      filter: true,
    },
    {
      headerName: "Date Applied",
      field: "DateApplied",
      filter: true,
      cellRenderer: (params) => {
        // const value = params.data.DateApplied.split("T")[0];
        // return `${value.toLocaleString()}`;
        return `${moment(params.data.DateApplied).format("MM-DD-YYYY")}`;
      },
    },
    {
      headerName: "Product Code",
      field: "ProductCode",
      filter: true,
    },
    {
      headerName: "Product Cost",
      field: "Cost",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(String(params?.data?.Cost).replace(/[^0-9.-]+/g, "")),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params?.data?.Cost).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    // {
    //   headerName: "Paid",
    //   field: "Paid",
    //   filter: true,
    //   cellDataType: "number",
    //   valueGetter: (params) =>
    //     parseFloat(String(params?.data?.Paid).replace(/[^0-9.-]+/g, "")),
    //   cellRenderer: (params) => {
    //     const value = parseFloat(
    //       String(params?.data?.Paid).replace(/[^0-9.-]+/g, "")
    //     );
    //     return `$${value.toLocaleString()}`;
    //   },
    // },
    {
      headerName: "Amount Applied",
      field: "CommissionApplied",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(String(params?.data?.CommissionApplied).replace(/[^0-9.-]+/g, "")),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params?.data?.CommissionApplied).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    // {
    //   headerName: "Product Balance",
    //   field: "Balance",
    //   filter: true,
    //   cellDataType: "number",
    //   valueGetter: (params) =>
    //     parseFloat(String(params?.data?.Balance).replace(/[^0-9.-]+/g, "")),
    //   cellRenderer: (params) => {
    //     const value = parseFloat(
    //       String(params?.data?.Balance).replace(/[^0-9.-]+/g, "")
    //     );
    //     return `$${value.toLocaleString()}`;
    //   },
    // },
    {
      headerName: "Dist C%",
      field: "DistributorCommissionPercentage",
      // filter: true,
      cellRenderer: (params) => {
        return `${params.data.DistributorCommissionPercentage}%`;
      },
    },
    {
      headerName: "Comm. Due",
      field: "CommissionDue",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params?.data?.CommissionDue).replace(/[^0-9.-]+/g, "")
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params?.data?.CommissionDue).replace(/[^0-9.-]+/g, "")
        );
        return `$${value.toLocaleString()}`;
      },
    },
    {
      headerName: "Reset Status",
      field: "ResetBlockedReason",
      filter: true,
      cellRenderer: (params) =>
        params.data?.CanResetCommission
          ? "Available"
          : params.data?.ResetBlockedReason || "Blocked",
    },
    {
      headerName: "Options",
      field: "",
      sortable: false,
      cellRenderer: (params) => {
        const canReset =
          canResetCommission && params.data?.CanResetCommission === true;
        return (
          <TableOptionsCell
            optionOne="View"
            optionOneType="warning"
            rowData={params.data}
            optionOneClickPath={`/InvoiceHome/${params.data.InvoiceID}`}
            optionTwo={canReset ? "Reset Commission" : ""}
            optionTwoType={canReset ? "failure" : ""}
            optionTwoClickFn={canReset ? resetCommission : undefined}
          />
        );
      },
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      <TitleBar
        entityName={`${commissionData[0]?.DistributorName}`}
        label={`Commissions for ${commissionData[0]?.InvoiceNumber}`}
        // rightFilterBarComponents={<Button variant="primary">Download</Button>}
      />
      <Table
        rowData={commissionData}
        columnDefs={tableHeadersCommissionsStatementsProducts}
      />
    </div>
  );
};

export default CommissionStatementsProducts;
